<template>
    <v-container>
      <v-col contain >
        <v-img
          src="@/assets/zbebarce.jpg"
          height="425"
        ></v-img>
      </v-col>
      <v-col>
        <h2 class="text-justify">{{ $t('servicioZbeBarcelona') }}</h2>
        <br>
        <p class="text-justify">{{ $t('descripcionZBE1') }}</p>
        <p class="text-justify">{{ $t('descripcionZBE2') }}</p>
        <a href="https://www.zbe.barcelona" target="_blank">{{$t('accede')}}</a>
      </v-col>
    </v-container>
</template>

<script>
export default {
  name: "PaginaZBE",

  data: () => ({
  })
};
</script>
